import { Component, OnInit, inject } from '@angular/core';
import { UserFormComponent } from "../user-form/user-form.component";
import { ProfileService } from '../../profile/services/profile.service';
import { AccessService } from '../../core/services/access.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-user-created',
  standalone: true,
  imports: [UserFormComponent],
  templateUrl: './user-created.component.html',
  styleUrl: './user-created.component.css'
})
export class UserCreatedComponent implements OnInit {
  private service = inject(UserService)
  protected profileService = inject(ProfileService)
  protected accessService = inject(AccessService)

  ngOnInit(): void {
    this.service.title.update((value) => 'Nuevo Usario');
  }
}
